export class OutgoingChatMessage {

  constructor(content: string) {
    this.content = content;
  }

  content: string;
}
